import { Client } from '../api-client';

// URL Generators
export const getOttVideoDetailsUrl = (childId: string) => `ott/v1/ott/video/details/${childId}`;
export const getOttVideoUserDataUrl = (childId: string) => `ott/v1/ott/video/${childId}/user-data`;
export const getOttVideoDppsUrl = () => 'v3/test-service/tests/user-test-student-mapping-list';
export const getOttPlaylistUrl = (playlistId: string) => `ott/v1/ott/playlist/${playlistId}`;
export const getOttSaveLaterUrl = () => 'ott/v1/ott/save-later';
export const getOttFetchStatsUrl = () => 'uxncc-be-go/internal/ott/fetch-stats';

// Fetchers
export const ottVideoDetailsFetcher = ({ queryKey }: any) => {
  const { childId } = queryKey[1];
  return Client.get(getOttVideoDetailsUrl(childId));
};

export const ottVideoUserDataFetcher = ({ queryKey }: any) => {
  const { childId } = queryKey[1];
  return Client.get(getOttVideoUserDataUrl(childId));
};

export const ottVideoDppsFetcher = (payload: any) => {
  return Client.post(getOttVideoDppsUrl(), payload);
};

export const ottPlaylistFetcher = ({ queryKey }: any) => {
  const { playlistId } = queryKey[1];
  return Client.get(getOttPlaylistUrl(playlistId));
};

export const ottSaveLaterFetcher = (payload: {
  isBookmark: boolean;
  ottPlaylistId: string;
  ottVideoId: string;
}) => {
  return Client.post(getOttSaveLaterUrl(), payload);
};

export const ottFetchStatsFetcher = ({ queryKey }: any) => {
  const { userId, typeId } = queryKey[1];
  const params = {
    userId,
    typeId,
  };

  return Client.get(getOttFetchStatsUrl(), { params });
};
